<template>
  <div class="agreement">
    <h2 class="center">
      <strong>统统付银行卡支付服务协议</strong>
    </h2>
    <p
      class="sp_cl"
    >统统付银行卡支付服务协议（以下简称“本协议”）是商盟商务服务有限公司（以下简称“商盟”或“统统付”）与用户(以下简称“用户”或“您”)就银行卡（借记卡/信用卡）支付服务（以下简称“本服务”）的使用等相关事宜所订立的有效协议。您通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受本协议，即表示您与商盟已达成协议并同意接受本协议的全部内容。</p>
    <p class="sp_cl">
      在接受本协议之前，请您仔细阅读本协议的全部内容
      <strong class="sp_underLine">（特别是以粗体下划线标注的内容）</strong>。如果您不同意本协议的任意内容，或者无法准确理解商盟对条款的解释，请不要进行后续操作。
    </p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >您应确保您具有完全民事权利能力和民事行为能力，您在使用本服务时的银行卡为您本人的银行卡，确保您使用银行卡的行为合法、有效且未侵犯任何第三方合法权益，否则因此造成商盟、银行卡所有人损失的，您应负责赔偿并承担全部法律责任，包括但不限于赔偿损失、临时锁定交易资金等。</strong>
    </p>
    <p
      class="sp_cl"
    >您同意并申请使用实名认证、银行卡实名验证服务，您授权商盟对商盟收集或由商户收集并转交商盟的您在使用本服务过程中所填写的包括但不限于姓名、银行卡卡号、手机号码、身份证号码等信息转交给发卡行以及商盟鉴权合作方进行校对核验；并同意将该银行卡与您此次在商户网站登录的用户进行绑定，以便您此次及今后进行支付。</p>
    <p class="sp_cl">为满足反洗钱等监管要求，您授权商盟有权留存您填写的信息以及快捷支付服务的交易信息。</p>
    <p class="sp_cl">
      您须妥善保管您的密码、数字证书、银行卡账户、卡号、有效期、CVV2/CVC2、证件号码、手机验证码等一切敏感信息，不得将敏感信息向他人泄露。如您遗失银行卡、泄露账户密码或相关信息的，您应及时通知发卡行及/或商盟，以减少可能发生的损失。
      <strong
        class="sp_underLine"
      >因您对密码、银行卡、数字证书、手机等保管不善产生的风险及损失由您本人承担。因泄露敏感信息或丢失银行卡/手机等所导致的损失须由您自行承担。</strong>
    </p>
    <p class="sp_cl">
      您应确保开通本服务所提供的手机号码为您本人所有。您保证将妥善保管您与使用的银行卡（借记卡/信用卡）绑定的手机号码，并且同意商盟有权将该手机号码发送的信息作为您的账户、密码和/或数字证书等方式之外的识别您的身份及支付指令的其它方式。
      <strong
        class="sp_underLine"
      >所有使用该手机号码所发送的操作指令均可视为您的授权操作行为，因此而产生的责任均由您承担。因手机或手机号码遗失、泄露、失窃等任一原因所导致的损失均由您自行承担。</strong>
    </p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >任何使用与您使用的银行卡（借记卡/信用卡）绑定的手机号码所发送至商盟计算机系统的支付指令，应被视为经您授权的不可撤销的付款指示，商盟对于计算机系统按照收到的符合约定的支付指令完成支付的行为不承担任何责任。</strong>
    </p>
    <p
      class="sp_cl"
    >商盟及您所持银行卡发卡行仅提供您与商家在购买交易过程中的相关款项的支付结算服务，因商家的商品或服务所产生的有关商品或服务本身的产品质量、服务质量、费用金额等争议均由您与提供商品或服务的商家自行协商解决，概与商盟及发卡行无关。</p>
    <p class="sp_cl">
      您不应将本服务用于任何非法的或违反本协议的目的。您应保证您在使用本服务时是合法、有效的，且您应保证将本服务用于合法或本协议约定的目的。您保证对您使用本服务所发出的指令的真实性和有效性负责。若您违反前述保证从而给商盟、发卡行或银行卡所有人造成损失的，您应负责赔偿并承担全部法律责任。您授权商盟可向您的开户行发送支付指令，扣划您银行账户资金。
      <strong
        class="sp_underLine"
      >您认可和同意：输入密码或短信验证码即视为您确认交易和交易金额并已不可撤销地向商盟发出指令，商盟有权根据您的指令委托银行或第三方从银行卡中扣划资金给收款人。届时您不应以非本人意愿交易或其他任何原因要求商盟退款或承担其他责任。</strong>
      您在对使用本服务过程中发出指令的真实性及有效性承担全部责任。您承诺，商盟依照您的指令进行操作的一切风险由您承担。
      <strong
        class="sp_underLine"
      >您认可您的使用记录数据、交易金额数据等均以商盟交易系统平台记录的数据为准。</strong>
    </p>
    <p class="sp_cl">
      您同意并授权商盟依据其自身判断对涉嫌欺诈或被他人控制并用于欺诈等非法目的的资金采取相应的措施，上述措施包括但不限于临时锁定资金、处置涉嫌欺诈的资金等。
      <strong
        class="sp_underLine"
      >您存在下列情形之一的，商盟有权立即终止您使用相关服务而无需承担任何责任：①您违反法律法规政策等规定的；②您违反本协议约定的；③您违反商盟或其他关联公司发布的使用本服务所必须遵守的协议、条款、规则、通告等相关规定的；④商盟认为向您提供本服务存在风险的。⑤您的银行卡有效期届满（如有）。</strong>
    </p>
    <p class="sp_cl">商盟有权向您收取使用本服务的服务费。收费方式及收费标准以商盟通过页面展示、手机应用、网站、其他电子渠道等适当方式公告的内容为准。</p>
    <p
      class="sp_cl"
    >您同意，本协议适用中华人民共和国大陆地区法律。就本协议所引起的任何争议和纠纷，均应由双方友好协商解决；如协商不成的，您和商盟均有权向商盟住所地人民法院提起诉讼。</p>
    <p
      class="sp_cl"
    >所有使用本服务而必须遵守的商盟已发布或将来可能发布的协议、附件和规则等均构成本协议不可分割的组成部分，与本协议具有同等法律效力。您同意，商盟有权对本协议内容进行相应修改或变更，并通过在商盟官方网站公布的形式进行通知，修改或变更后的协议内容在商盟官方网站公布即有效代替原来的协议，您须定期关注、注意商盟官方网站并定期审阅本协议及其变更内容。若您不同意商盟对本协议所作的任何修改或变更，您应立即停止使用本服务。若您在本协议内容公布变更后仍继续使用本服务，则表示您已充分阅读、理解、同意并接受修改或变更后的协议内容，也将遵循修改或变更后的协议内容使用本服务。</p>
    <p class="sp_cl">本协议未尽事宜，您需遵守商盟官方网站上公布的《统统付服务协议》及相关规则。</p>
    <br />
    <br />
    <br />
    <p class="sp_cl">
      <strong>若您为华夏银行持卡人，使用华夏银行银行卡（借记卡/信用卡）进行协议支付，您还同意与华夏银行股份有限公司签订《华夏银行个人客户“网联协议支付”服务协议》，并通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受《华夏银行个人客户“网联协议支付”服务协议》的全部内容。</strong>
    </p>
    <h2 class="center">
      <strong>华夏银行个人客户“网联协议支付”服务协议</strong>
    </h2>
    <p class="sp_lf">甲方：华夏银行持卡人</p>
    <p class="sp_lf">乙方：华夏银行股份有限公司</p>
    <h2 class="center">
      <strong>风险提示</strong>
    </h2>
    <p class="sp_cl">为确保甲方安全使用乙方网联协议支付服务，保护账户资金安全，请甲方务必注意以下几点：</p>
    <p class="sp_cl">
      <strong>1、选择专用于协议支付的华夏卡。为保障甲方的资金安全，建议甲方选择资金余额相对较少的华夏卡专门用于协议支付服务，不要将所有华夏卡均签约协议支付业务。 </strong>
    </p>
    <p class="sp_cl">
      <strong>2、甲方签约协议支付的华夏卡需在我行开通账务短信通知服务，方可成功签约。请在签约协议支付业务前，确保签约的华夏卡已开通了账务短信通知功能，以便甲方的华夏卡发生资金变化时，可随时了解并查询。请甲方更换手机号码后，及时到乙方营业机构更新甲方的账务短信通知手机号码，并立即解约协议支付业务，然后使用更换后的手机号码在第三方支付机构重新进行协议支付业务签约。</strong>
    </p>
    <p class="sp_cl">
      <strong>3、能够承受协议支付的相关风险。由于本业务需要在事先或者首次支付时进行签约，签约时第三方支付机构需要采集甲方的姓名、卡号、证件号码、签约账务短信通知的手机号码等信息，这些信息可能存在被泄露、导致资金损失的风险；甲方在签约完成进行支付时，仅使用用户协议号进行支付，可能导致由于协议号泄露等，被他人盗用发生资金损失的风险。</strong>
    </p>
    <p
      class="sp_cl"
    >为明确甲、乙双方的权利和义务，规范双方业务行为，根据《中华人民共和国合同法》、《中华人民共和国电子签名法》、《中华人民共和国反洗钱法》等法律以及网联清算有限公司相关业务规范，本着平等互利的原则，经甲、乙双方协商一致，就借记卡/信用卡网联协议支付服务（以下简称“本服务”）的使用等相关事项达成本协议（以下简称“本协议”），双方保证遵守以下条款。甲方通过互联网（Internet）点击确认或以其他方式选择接受本协议，即表示甲方同意接受本协议的全部约定内容，确认承担由此产生的责任。</p>
    <p class="sp_cl">
      一、在接受本协议之前，请甲方仔细阅读本协议的全部内容（特别是以
      <strong class="sp_underLine">粗体下划线</strong>
      标注的内容）。如果甲方不同意本协议的任何内容，或者无法准确理解相关条款的解释，请不要进行后续操作。
    </p>
    <p class="sp_cl">
      二、甲方应确保甲方在使用本服务时绑定的借记卡/信用卡为甲方本人所有，并确保甲方将甲方在
      <span class="sp_underLine">（第三方支付机构名称，以下简称“支付机构”）</span>
      注册的用户ID与该借记卡/信用卡绑定且用其支付的行为合法、有效，未侵犯任何第三方合法权益；否则因此造成我行、持卡人损失的，甲方应负责赔偿并承担法律责任。
    </p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >三、甲方确认同意我行对由支付机构收集并转交我行的甲方信息（包括在使用本服务过程中所填写的包括但不限于姓名、借记卡/信用卡卡号、签约账务短信通知的手机号码、证件号码等）进行校对核验并生成支付协议号；同意将该借记卡/信用卡在支付机构进行签约绑定，以便甲方此次及今后进行支付。</strong>
    </p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >四、一旦上述签约绑定成功，我行为甲方生成支付协议号并将该协议号发送至支付机构，甲方在支付机构发起支付指令后，即视为甲方本人确认支付金额，并同意及授权由支付机构以协议号为支付标识转交我行进行后续处理。甲方同意并授权我行按照支付机构的交易指令从甲方绑定的借记卡/信用卡账户中支付相应款项。</strong>
    </p>
    <p class="sp_cl">
      五、甲方应妥善保管绑定的该卡开户户名、卡号及相关的证件类型及证件号码、签约账务短信通知的手机号码、固定电话、通信地址等与该卡有关的一切信息（以下简称“身份信息及卡信息”）。如甲方遗失借记卡/信用卡、泄露身份信息及卡信息，甲方应及时挂失并通知我行及支付机构，以减少可能发生的损失。
      <strong
        class="sp_underLine"
      >因甲方泄露身份信息、卡信息、密码 ，丢失借记卡/信用卡等原因所致的损失需由甲方承担，我行不承担责任。</strong>
    </p>
    <p
      class="sp_cl"
    >六、为防范风险，保障甲方的资金安全，我行设置了支付限额。甲方在使用本服务时需受我行设置的支付限额的约束。甲方可以登录我行手机银行/个人网银，或者至我行柜台进行支付限额的修改，修改后的支付限额不能高于我行为该支付机构设定的支付限额。如实际支付金额大于支付限额，我行将拒绝执行交易指令，由此造成的损失由甲方本人承担。</p>
    <p
      class="sp_cl"
    >七、甲方不得利用协议支付业务进行包括但不限于套现、虚假交易、洗钱、非法集资等非法行为，且甲方有义务配合我行进行相关调查，一旦甲方拒绝配合我行进行相关调查，或我行认为甲方存在或涉嫌套现、虚假交易、洗钱、非法集资等非法行为，或存在欺诈或违反诚信原则的行为，以及违反本协议约定的，我行有权立即采取以下一种、多种或全部措施：</p>
    <p class="sp_cl">（1）暂停或终止提供本协议项下协议支付服务；（2）终止本协议；（3）取消甲方的用卡资格。</p>
    <p
      class="sp_cl"
    >八、我行有权根据法律、法规、部门规章、监管规定或我行业务发展需要修改支付限额，或变更、暂停本协议项下协议支付业务服务，或修改、变更、终止本协议相关规定，如需甲方确认的，我行通过官方网站或营业网点等渠道进行公告，甲方继续使用协议支付业务的，视为甲方确认。如不需甲方确认的，则自调整或变更之日起对甲方生效。本协议终止后，支付机构在协议终止前已接收并发送至我行的交易指令仍有效，甲方应承担其后果。</p>
    <p class="sp_cl">
      <strong>九、甲方在签约网联协议支付服务时向我行提供的甲方本人及他人有关信息（包括我行不能从公众渠道取得的甲方及他人的个人基本信息、业务相关信息及其他有关信息）真实、准确、有效、完整且已取得他人的同意，我行对甲方提供的信息有保密的义务。我行有权在法律、法规、监管规定、有权机关规定的期限内对甲方提供的信息进行留存并在内部使用（超过上述期限的，我行有权销毁）；有权将甲方提供的信息提供给征信机构或根据法律法规、监管规定、司法机关的强制命令提供甲方提供的信息；有权为履行本协议之目的，将甲方提供的信息披露给我行代理人，并取得代理人的保密承诺。</strong>
    </p>
    <p class="sp_cl">十、甲方如对交易存在疑义，请尽快向乙方提出申明；对于交易订单超过180天的，乙方将不予受理。</p>
    <p class="sp_cl">十一、本协议终止后，支付机构在协议终止前已接收并发送至我行的交易指令仍有效。</p>
    <br />
    <br />
    <br />
    <p
      class="sp_cl"
    >若您为中国银行持卡人，使用中国银行借记卡进行快捷支付，您还同意与中国银行股份有限公司签订《中国银行股份有限公司借记卡快捷支付服务协议》，并通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受《中国银行股份有限公司借记卡快捷支付服务协议》的全部内容。</p>
    <h2 class="center">
      <strong>中国银行股份有限公司借记卡快捷支付服务协议</strong>
    </h2>
    <p class="sp_cl">请客户认真阅读本协议文本。</p>
    <p
      class="sp_cl"
    >1. 中国银行股份有限公司借记卡快捷支付业务（以下简称“快捷支付业务”）是中国银行股份有限公司（以下简称“中国银行”）和商盟商务服务有限公司（下称“合作支付机构”）联合为中国银行借记卡持卡客户（以下简称“客户”）提供的一项电子支付服务。凡是持有中国银行股份有限公司在中国大陆地区发行的借记卡的客户，均可申请该业务。</p>
    <p
      class="sp_cl"
    >2. 客户在签约快捷支付业务时，将收到中国银行发送的带有手机交易码的签约确认短信。客户应认真阅读本协议，在同意本协议约定内容的前提下输入手机交易码。客户输入手机交易码即视同为同意本协议内容。</p>
    <p class="sp_cl">
      <strong>3. 客户通过互联网（Internet）在合作支付机构网站或客户端，选择在线与中国银行签订本服务协议，将指定的借记卡与此时登录的账户进行关联，开通快捷支付功能，并承担由此产生的一切责任。</strong>
    </p>
    <p class="sp_cl">
      4. 客户同意，中国银行以
      <strong>合作支付机构</strong>
      <strong></strong>传送至中国银行的户名、卡号、手机号码、
      <strong>证件号码</strong>等身份要素作为确认客户身份、为客户开通快捷支付业务的唯一证据。中国银行比对户名、卡号、手机号码、
      <strong>证件号码</strong>与客户在银行预留信息一致后，通过95566发送手机交易码至客户预留手机号上，并对
      <strong>合作支付机构</strong>传送的客户填写的手机交易码进行验证，验证一致通过后，完成客户指定的借记卡与此时所登录账户的关联。
      <strong>客户须保证在中国银行预留手机号码为本人手机号码并确保其准确性。</strong>基于提高交易安全的目的，中国银行有权变更上述身份要素。客户须妥善保管本人中国银行借记卡信息，本人身份信息、手机交易码、安全认证工具等敏感信息，不得将敏感信息向他人透露。
      <strong>因客户银行预留信息错误，或个人信息、手机等保管不善产生的风险及损失由客户本人承担。</strong>
    </p>
    <p class="sp_cl">
      <strong
        class="sp_underLine"
      >5. 开通快捷支付业务后，客户同意并授权中国银行在本协议约定的服务范围内，将其所关联借记卡的原有支付验证方式变更为按照合作支付机构发送的交易指令从客户指定的借记卡账户中支付相应款项。客户需在其绑定的借记卡的余额内进行支付，否则中国银行有权拒绝执行交易指令。</strong>
    </p>
    <p class="sp_cl">
      6. 中国银行可根据业务发展需要，设置或修改支付限额，客户对此无异议，客户办理快捷支付业务时需同时受中国银行和
      <strong>合作支付机构</strong>设置的支付限额的约束。在任何情况下，支付金额不应超过中国银行或
      <strong>合作支付机构</strong>设置的支付限额（以较低者为准）。如实际支付金额大于规定的支付限额，中国银行将拒绝执行交易指令。
    </p>
    <p class="sp_cl">
      7. 本协议项下，中国银行仅提供通过
      <strong>合作支付机构</strong>发生的支付结算服务。
      <strong>客户因通过合作支付机构购买商品而产生的一切关于商品或服务质量、商品交付，交易款项扣收与划付的争议均由客户与商户或商品/服务的实际销售商自行协商解决。</strong>
    </p>
    <p class="sp_cl">8. 客户使用借记卡快捷支付业务应防范的风险包括但不限于：</p>

    <p
      class="sp_cl"
    >（1）客户借记卡快捷支付使用的用户名、账户、密码等重要信息可能被其他人猜出、偷窥或通过木马病毒、假冒网站、欺诈电话或短信等手段窃取，从而导致客户信息泄露、资金损失、账户被恶意操作等后果。</p>
    <p
      class="sp_cl"
    >（2）手机可能被盗或未经许可被他人使用，若手机银行密码同时被窃取，可能造成账户资金损失等情况；若客户更换手机号时未取消以原手机号开通的短信提醒服务，当原手机号被他人使用时，可能造成客户的账户信息泄露等情况。</p>
    <p class="sp_cl">（3）客户使用设备的操作系统、杀毒软件、网络防火墙等客户端软件未及时更新或安装补丁程序，可能导致客户信息泄露、资金损失、账户被恶意操作等后果。</p>
    <p class="sp_cl">9. 客户应采取风险防范措施，安全使用借记卡快捷支付业务，相关措施包括不限于：</p>
    <p class="sp_cl">（1）妥善保护借记卡快捷支付业务使用的用户名、账户、密码等重要身份识别标识、身份认证信息及工具，确保上述重要信息和认证工具不经口头或其它方式发生泄露或被盗用。</p>
    <p class="sp_cl">（2）对所使用设备的操作系统、杀毒软件、网络防火墙等客户端软件采取有效的措施（如及时更新系统或安装补丁程序等）防范操作系统软件漏洞风险、电子设备中的病毒等。</p>
    <p class="sp_cl">（3）妥善保管借记卡、手机及与借记卡快捷支付业务相关的重要身份证件等资料，不交给其他人保管，不放置在不安全场所。</p>
    <p
      class="sp_cl"
    >（4）避免使用容易被其他人猜出或破解的密码（如：采用生日、电话号码等与个人信息相关的信息或具有规律性的数字或字母组合作为快捷支付业务密码），避免设置与其他用途相同的密码（如：采用电子邮件密码作为借记卡快捷支付密码）。客户应定期或不定期更新其密码。</p>
    <p class="sp_cl">（5） 应经常关注账户内资金变化，如发现任何通过中国银行借记卡快捷支付从事的未经客户许可的操作及交易，客户应马上与支付机构或中国银行取得联系。</p>
    <p
      class="sp_cl"
    >10. 借记卡快捷支付业务资金清算可能出现异常及差错交易，银行及合作支付机构将对异常及差错交易及时进行纠正处理。银行及合作支付机构将根据客户要求提供交易记录的时间和方式等信息。</p>
    <p
      class="sp_cl"
    >11. 客户不得利用中国银行快捷支付业务进行虚假交易、洗钱、诈骗、恐怖融资等行为，且有义务配合中国银行进行相关调查，一旦客户拒绝配合进行相关调查或中国银行认为客户存在或涉嫌虚假交易、洗钱或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，中国银行有权采取以下一种、多种或全部措施：（1）暂停或终止提供本协议项下快捷支付业务服务；（2）终止本协议；（3）取消客户的用卡资格。</p>
    <p class="sp_cl">
      12. 客户同意中国银行就快捷支付业务的开展，向支付机构提供客户留存在中国银行的户名、银行卡号、
      <strong>证件号码</strong>、手机号码等信息。
    </p>
    <p class="sp_cl">13. 客户可以登录中国银行官方网站撤销本人名下指定借记卡与支付机构账户关联的快捷支付功能。</p>
    <p class="sp_cl">
      14. 中国银行系统升级、业务变化、收费变更，或根据业务发展需要修改本协议，中国银行将提前进行公告。若客户有异议，有权选择撤销相关服务，若客户选择继续接受该服务的，视为客户同意并接受相关业务或协议按变更或修改后的内容执行。双方同意，本协议所称公告均指在中国银行网点、中国银行网站
      <strong>【http://www.boc.cn】</strong>、电子银行渠道等进行公告。
    </p>
    <p class="sp_cl">
      <strong>15. 选择打勾的客户，视同已通读上述条款，对条款的内容及其后果已充分理解，对所有内容均无异议。</strong>
    </p>
    <p
      class="sp_cl"
    >本协议在客户于支付机构提供的页面服务协议栏位打勾并提交后生效。本协议的生效、履行及解释均使用中华人民共和国法律（为本协议之目的，不含中国香港、澳门、台湾地区法律）。本协议项下的争议向中国银行所在地人民法院起诉。</p>
    <br />
    <br />
    <br />
    <p class="sp_cl">
      <strong>若您为中国工商银行持卡人，使用中国工商银行银行卡（借记卡/信用卡）进行快捷支付，您还同意与中国工商银行股份有限公司签订《中国工商银行快捷支付业务服务协议》，并通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受《中国工商银行快捷支付业务服务协议》的全部内容。</strong>
    </p>
    <h2 class="center">
      <strong>中国银行信用卡快捷支付业务线上服务协议</strong>
    </h2>
    <p class="sp_cl">
      <strong>在接受本协议之前，请您仔细阅读本协议的全部内容（特别是以粗体标注的内容）。如果您不同意本协议的任何内容，或者无法准确理解相关条款的解释，请不要进行后续操作。</strong>如有疑义,请及时拨打中国银行信用卡客户服务热线4006695566咨询或（8610）66085566。
    </p>
    <p class="sp_cl">
      为规范双方业务行为，本协议由甲方（中国银行信用卡个人客户）、乙方（中国银行股份有限公司）本着平等互利的原则，就信用卡快捷支付业务相关事宜达成本协议。甲方通过互联网（Internet）点击确认并接受本协议，在线与乙方签订本服务协议，开通商盟商务服务有限公司（统统付）快捷支付业务功能并承担由此产生的一切责任。
    </p>
    <p class="sp_cl">
      第一条 业务定义
    </p>
    <p class="sp_cl">
      中国银行股份有限公司信用卡快捷支付业务（以下简称“快捷支付业务”）是乙方和商盟商务服务有限公司（统统付）向甲方提供的，将甲方信用卡与统统付账户签约绑定后，乙方即可根据统统付发送的指令，扣划甲方信用卡账户资金的支付服务业务。
    </p>
    <p class="sp_cl">
      第二条 权利和义务
    </p>
    <p class="sp_cl">
      一、“快捷支付”签约的信用卡为甲方本人申请并使用，保证在签约过程中提供的信息真实、准确、有效，确保支付行为合法，并未侵犯任何第三方合法权益，否则因此给乙方或第三方造成损失的，<strong>由甲方负责赔偿并承担全部法律责任。</strong>
    </p>
    <p class="sp_cl">
      <strong>二、甲方同意将签约过程中填写的卡号、有效期、卡片验证码、客户姓名、公民身份证号码、手机号码和手机动态密码等要素作为确认甲方身份，并同意将指定信用卡卡号与甲方在统统付注册的会员账号建立签约关系。乙方收到统统付发送的上述信息后，验证上述信息与甲方在乙方预留的信息一致后，即视为获得甲方的有效授权，乙方可根据统统付的指令直接从该信用卡中扣除相应款项直至终止绑定为止（终止绑定指甲方通过统统付或直接通过乙方渠道发出指令，解除信用卡快捷支付签约关系；或因甲方签约时填写的信息发生变动导致的签约关系解除）。基于提高交易安全的目的,乙方有权变更验证流程和上述要素作为验证标准的权利。</strong>甲方须妥善保管本人中国银行信用卡卡片信息、本人身份信息、手机动态密码、安全认证工具、交易信息等敏感信息，不得将敏感信息向他人透露。<strong>因甲方个人信息、信用卡卡片信息、手机等保管不善产生的风险及损失由甲方本人承担，并承担因此给乙方或第三方造成的损失。</strong>
    </p>
    <p class="sp_cl">
      <strong>三、“快捷支付”签约成功后，即视为甲方授权乙方按照统统付的交易指令从签约的信用卡上主动扣划资金。</strong>甲方不应以未在交易单据中签名、签名不符、非本人意愿交易、未验证信用卡支付密码等原因否认交易、要求乙方退款或承担责任。
    </p>
    <p class="sp_cl">
      四、乙方可根据业务发展需要，设置或修改支付限额，甲方对此无异议。任何情况下，甲方的支付限额不应超过乙方及统统付设置的支付限额（以较小者为准），同时也受限于信用卡支付额度。如实际支付金额大于支付限额，乙方有权拒绝执行统统付发送的交易指令。
    </p>
    <p class="sp_cl">
      五、甲方不得利用信用卡快捷支付业务进行套现、虚假交易、洗钱等行为，且有义务配合乙方进行相关调查，一旦甲方拒绝配合进行相关调查或乙方认为存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，乙方有权采取以下一种、多种或全部措施：
    </p>
    <p class="sp_cl">
      （1）暂停或终止提供本协议项下统统付快捷支付服务；
    </p>
    <p class="sp_cl">
      （2）终止本协议；
    </p>
    <p class="sp_cl">
      （3）中国银行股份有限公司信用卡领用合约、章程中约定的相关措施。
    </p>
    <p class="sp_cl">
      <strong>六、甲方授权并同意乙方就统统付快捷支付业务向统统付提供甲方留存在乙方的卡号、有效期、卡片验证码、客户姓名、公民身份证号码、手机号码等信息的验证服务。并已知晓上述服务可能会使相关服务合作方据此知悉甲方的相关信息。</strong>
    </p>
    <p class="sp_cl">
      七、乙方仅为甲方提供安全、可靠的支付结算服务。甲方因通过统统付或其合作方购买商品而产生的一切关于商品或服务质量、商品交付、交易款项扣收与划付的争议均由甲方与商品或服务的实际销售商以及统统付自行协商解决，与乙方无关。
    </p>
    <p class="sp_cl">
      第三条 协议的效力
    </p>
    <p class="sp_cl">
      <strong>一、因乙方对银行系统进行升级、改造而引起的服务取消、暂停或者服务内容、项目、方式等变化，或根据业务发展需要修改本协议、服务时间或其他业务规则，乙方将在乙方网站【http://www.boc.cn】等提前进行公告，不再逐一通知甲方，若甲方拒绝此修改，有权在公告规定的合理时间内注销相关服务，若甲方在公告的业务变更或协议修改生效日期后未注销相关服务，即视为甲方同意并接受该变更或修改。</strong>
    </p>
    <p class="sp_cl">
      二、本协议终止后，统统付在协议终止前已发送的交易指令仍有效，客户应承担其后果。
    </p>
    <p class="sp_cl">
      <strong>三、本协议自甲方在统统付的网站点击“确认”后生效。对带有加粗的条款的内容及其后果已充分理解，对所有内容均无异议。</strong>
    </p>
    <p class="sp_cl">
      四、本协议的生效、履行及解释均适用中国法律。
    </p>
    <p class="sp_cl">
      五、甲乙双方在履行本协议时发生的争议，由双方友好协商；协商不成，任何一方均可提交为甲方开立本协议项下绑定信用卡的乙方分支机构所在地有管辖权的人民法院诉讼解决。
    </p>
    <br/>
    <br/>
    <br/>
    <p class="sp_cl">
      若您为中国工商银行持卡人，使用中国工商银行银行卡（借记卡/信用卡）进行快捷支付，您还同意与中国工商银行股份有限公司签订《中国工商银行快捷支付业务服务协议》，并通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受《中国工商银行快捷支付业务服务协议》的全部内容。
    </p>
    <h2 class="center">
      <strong>中国工商银行快捷支付业务服务协议</strong>
    </h2>

    <p class="sp_cl">
      <strong>在接受本协议之前，请您仔细阅读本协议的全部内容（特别是以粗体标注的内容）。如有疑义请及时通过工商银行网站或拨打客户服务热线（95588）咨询。如您不同意本协议的任何内容，或者不能准确理解本协议的任何条款，请不要进行后续操作。</strong>
    </p>
    <p
      class="sp_cl"
    >为明确双方的权利和义务，规范双方业务行为，甲方（个人客户）、乙方（中国工商银行）本着平等互利的原则，就快捷支付业务相关事宜达成本协议。甲方通过互联网（Internet）点击确认或以其他方式选择接受本协议，即表示甲方同意接受本协议的全部约定内容，确认承担由此产生的一切责任。</p>
    <p class="sp_cl">
      <strong>第一条 业务定义</strong>
    </p>
    <p class="sp_cl">下列用语在本协议中的含义为：</p>
    <p
      class="sp_cl"
    >“快捷支付”是指乙方与商盟商务服务有限公司（下称‘非银行支付机构’）向甲方提供的，将甲方银行卡与支付账户签约绑定后，乙方即可根据非银行支付机构发送的指令，扣划甲方银行卡账户资金的支付服务业务。</p>
    <p class="sp_cl">"快捷支付"的签约和使用渠道包括但不限于：计算机、手机、电话、掌上电脑、电视、自助终端等设备，具体以乙方及非银行支付机构提供的快捷支付业务为准。</p>
    <p class="sp_cl">
      <strong>"手机号码"指甲方在乙方开立银行账户时预留信息中的手机号码或者甲方在乙方认可的第三方机构（例如电信运营商等）办理的本人手机号码。</strong>
    </p>
    <p class="sp_cl">
      <strong>第二条 权利和义务</strong>
    </p>
    <p class="sp_cl">
      一、甲方应确保用于"快捷支付"签约的银行卡为本人所有，保证在签约过程中提供的信息真实、准确、有效，确保支付行为合法并未侵犯任何第三方合法权益，否则因此造成乙方及其持卡人损失的，由甲方负责赔偿并承担全部法律责任。
    </p>
    <p class="sp_cl">
      <strong>二、甲方同意将签约过程中所填写的包括但不限于姓名、银行卡号、手机号码、身份证件号码、信用卡有效期等要素用于身份验证，并同意将指定银行卡号与甲方在非银行支付机构开立的指定会员账号建立签约关系。</strong>乙方收到非银行支付机构发送的上述信息后，将上述信息与甲方在乙方预留的客户信息进行比对验证，验证通过后，乙方为甲方签约银行卡开通快捷支付业务。
      <strong>甲方同意乙方将上述信息发送至乙方认可的第三方机构（例如电信运营商等）进行信息查询与核验。</strong>乙方承诺对甲方签约信息保密，但法律法规和规章另有规定或监管部门等有权机关另有要求的除外。
      <strong>甲方同意乙方可根据业务需要变更验证流程、要素和验证标准。</strong>
    </p>
    <p class="sp_cl">
      <strong>三、"快捷支付"签约成功后，即视为甲方授权乙方按照非银行支付机构的交易指令从签约银行卡上主动扣划资金。届时甲方不应以未在交易单据中签名、签名不符、非本人意愿交易、未验证银行卡支付密码、未验证银行卡支付盾等原因要求乙方退款或承担其他责任。</strong>
    </p>
    <p class="sp_cl">
      四、甲方应妥善保管银行卡开户户名、开户类型、与之相关的证件类型及证件号码、手机号码、固定电话、通信地址等相关信息，如遗失银行卡或泄露上述相关信息，甲方应及时通知乙方并办理挂失或销户等相关手续，减少可能发生的损失。
      <strong>挂失或销户前的损失，以及因甲方泄露银行卡密码、支付机构账号密码、支付机构支付密码和手机动态密码、数字证书、U-KEY、丢失银行卡等所致损失，由甲方自行承担。</strong>
    </p>
    <p
      class="sp_cl"
    >五、甲方可通过乙方网上银行等渠道自助查询"快捷支付"业务签约情况并对卡账户支付限额进行管理。任何情况下，甲方设置的支付限额不应超过乙方及非银行支付机构设置的最大支付限额，如实际支付金额大于支付限额，乙方有权拒绝执行交易指令。乙方保留根据交易安全需要设置或修改最大支付限额的权利。信用卡支付限额同时受限于卡信用额度。Ⅱ类、Ⅲ类账户受账户自身限额限制。</p>
    <p
      class="sp_cl"
    >六、甲方不得利用快捷支付业务进行套现、虚假交易、洗钱等违法行为，有义务配合乙方进行相关调查。如若甲方拒绝配合进行相关调查或乙方认为存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，乙方有权采取以下一种、多种或全部措施：（1）暂停或终止提供本协议项下快捷支付服务；（2）终止本协议；（3）取消甲方的用卡资格。若因甲方的前述行为而给乙方造成损失的，甲方应负责赔偿并承担全部法律责任。</p>
    <p class="sp_cl">
      <strong>第三条 法律适用条款</strong>
    </p>
    <p class="sp_cl">本协议的成立、生效、履行和解释，均适用中华人民共和国法律（除香港、澳门、台湾地区法律）；法律无明文规定的，可适用通行的金融惯例。</p>
    <p class="sp_cl">本协议是乙方的其他既有协议和约定的补充而非替代文件，如本协议与其他既有协议和约定有冲突，应以本协议为准。</p>
    <p class="sp_cl">
      <strong>第四条 差错和争议的解决</strong>
    </p>
    <p
      class="sp_cl"
    >乙方仅为甲方提供安全可靠的支付结算服务，依据非银行支付机构提供的交易指令实施资金扣划。对于因购买商品或服务而产生的一切关于商品、服务及费用扣收的争议均由甲方与非银行支付机构自行协商解决，与乙方无关。</p>
    <p class="sp_cl">
      双方在履行本协议的过程中，如发生争议，应尽量协商解决。协商不成的，任何一方均应向
      <strong>甲方绑定银行卡的开户行所在地有管辖权的人民法院</strong>提起诉讼。
    </p>
    <p class="sp_cl">
      <strong>第五条 协议的终止</strong>
    </p>
    <p class="sp_cl">
      <strong>如因签约卡/折注销、补（换）卡/折等任何原因导致卡/折号变更，须重新签订"快捷支付"签约关系。</strong>
    </p>
    <p class="sp_cl">
      <strong>第六条 协议的效力</strong>
    </p>
    <p class="sp_cl">
      <strong>本协议与本行借记卡或贷记卡章程或协议相冲突部分，以本协议为准。</strong>
    </p>
    <p class="sp_cl">
      <strong>甲方同意，乙方有权变更、暂停本协议项下快捷支付业务服务，有权修改、终止本协议，并于执行前通过乙方网站或其他任何形式进行公告。修改本协议的公告到期后甲方继续办理快捷支付业务的，视同接受有关本协议、快捷支付业务服务的修改内容。甲方不同意的，可以终止本协议。</strong>
    </p>
    <br />
    <br />
    <br />
    <p class="sp_cl">
      <strong>若您为邮储银行持卡人，使用邮储银行借记卡进行快捷支付，您还同意与中国邮政储蓄银行签订《中国邮政储蓄银行借记卡统统付快捷支付业务线上服务协议》，并通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受《中国邮政储蓄银行借记卡统统付快捷支付业务线上服务协议》的全部内容。</strong>
    </p>
    <h2 class="center">
      <strong>中国邮政储蓄银行借记卡统统付快捷支付业务线上服务协议</strong>
    </h2>
    <p class="sp_cl">请客户认真阅读本协议全文，尤其是带有▲▲标记的条款。如有疑义，请及时拨打中国邮政储蓄银行客户服务热线95580咨询。</p>
    <p
      class="sp_cl"
    >1、中国邮政储蓄银行借记卡统统付快捷支付业务是中国邮政储蓄银行（以下简称"邮储银行"）和商盟商务服务有限公司（以下简称"统统付"）联合为邮储银行借记卡客户（以下简称"客户"）提供的一项通过统统付进行便捷支付的业务。凡是持有邮储银行借记卡且同时为统统付用户的客户，均可申请该业务。</p>
    <p class="sp_cl">2、客户通过互联网（Internet）在统统付网站点击确认选择在线签订本服务协议，开通统统付快捷支付业务功能并承担由此产生的相关法律责任。</p>
    <p
      class="sp_cl"
    >▲▲3、客户同意邮储银行以统统付传送至邮储银行的户名、卡号、身份证号、手机号码和手机短信验证码作为确认客户身份、为客户开通统统付快捷支付业务的唯一依据。基于提高交易安全的目的，邮储银行有权变更上述确认身份要素。客户应保证业务开通时在邮储银行预留的手机号码为本人手机号码，否则由此导致的客户损失，邮储银行不承担赔偿责任。客户须妥善保管本人邮储银行借记卡信息、身份信息、手机短信验证码、安全认证工具等敏感信息，不得将敏感信息向他人透露。因客户个人信息、银行卡片信息、手机等保管不善产生的风险及损失由客户本人承担。</p>
    <p class="sp_cl">▲▲4、客户同意并授权邮储银行在校验客户手机短信验证码通过后，按照统统付的交易指令从客户指定的借记卡账户中支付相应款项，客户对此无异议。</p>
    <p
      class="sp_cl"
    >▲▲5、邮储银行不对统统付提交的扣款交易指令进行实质性审核，不负责审核统统付提交扣款指令的真实性、合法性、准确性。客户如对邮储银行依据统统付指令进行扣款的行为发生争议，应与其统统付协商解决。</p>
    <p
      class="sp_cl"
    >▲▲6、为确保客户网上支付资金安全，邮储银行有权设置或修改支付限额。客户在支付时需同时受邮储银行和统统付设置的支付限额的约束。如客户实际支付金额大于规定的支付限额，邮储银行将拒绝执行该笔交易。</p>

    <p
      class="sp_cl"
    >▲▲7、客户承诺在指定的银行付款账户中保留足够的余额，并保持账户处于正常状态。因付款账户余额不足、账户被冻结、销户等原因而导致的无法成功支付费用及所造成的纠纷和违约责任、损失等法律后果客户自行承担。</p>
    <p
      class="sp_cl"
    >▲▲8、邮储银行仅提供通过统统付发生的支付结算服务。客户因通过统统付或统统付商户购买商品而产生的一切关于商品或服务质量、商品交付的争议，由客户与商品/服务的实际销售商以及统统付自行协商解决。</p>
    <p
      class="sp_cl"
    >▲▲9、客户不得利用邮储银行统统付快捷支付业务进行套现、虚假交易、洗钱等行为，且有义务配合邮储银行进行相关调查，如有违反，邮储银行有权采取以下一种或多种措施：（1）暂停或终止提供本协议项下统统付快捷支付业务；（2）终止本协议；（3）取消客户的用卡资格。</p>
    <p
      class="sp_cl"
    >10、因电力中断、电脑、网络等通讯故障，或不可抗力等因素导致统统付快捷支付业务中断或者处于不稳定状态，邮储银行已尽力采取补救措施但仍未能避免损失的情况下，不承担相关责任。</p>

    <p
      class="sp_cl"
    >▲▲11、邮储银行有权变更、暂停或终止本协议，但必须于执行前通过邮储银行网站或其他任何形式进行公告。相关公告经网站发布视为客户已收到。客户在公告执行后继续办理统统付快捷支付业务的，视同接受有关本协议和统统付快捷支付业务服务修改、变更的内容。 客户不同意的，可以在履行本协议项下应尽义务后解除本协议。</p>
    <p
      class="sp_cl"
    >12、如邮储银行与统统付业务合作终止后，自终止之日起本协议自动失效。客户如需注销快捷支付业务，客户可以通过统统付端发起注销申请，业务注销自邮储银行同意并在银行系统中设置成功后生效。</p>
    <p class="sp_cl">13、客户在统统付快捷支付业务开通页面上点击确认，视同已通读上述条款，对带有▲▲标记的条款的内容及其后果已充分理解，对所有内容均无异议。</p>
    <p class="sp_cl">14、本协议自客户在统统付网站页面点击确认后立即生效。本协议的生效、履行及解释均适用中国法律。</p>
    <br />
    <br />
    <br />
    <p class="sp_cl">
      <strong>若您为建设银行持卡人，使用建设银行活期储蓄账户或信用卡账户进行快捷支付，您还同意与中国建设银行股份有限公司签订《中国建设银行总对总快捷客户授权协议》，并通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受《中国建设银行总对总快捷客户授权协议》的全部内容。</strong>
    </p>
    <h2 class="center">
      <strong>中国建设银行总对总快捷客户授权协议</strong>
    </h2>
    <p
      class="sp_cl"
    >中国建设银行总对总快捷客户授权协议（以下简称"本协议"）是中国建设银行股份有限公司（以下简称“甲方”）与个人客户（以下简称“乙方”）就中国建设银行总对总快捷电子支付服务的相关事宜达成的协议。</p>
    <p class="sp_cl">
      <strong>第一条、</strong> 总对总快捷业务是指持有甲方活期储蓄账户或信用卡账户的乙方，通过网银盾或短信验证码等认证方式，验证账号、手机号等身份信息后，授权指定商户在一定限额内就该银行账户向甲方发出扣款指令，并授权甲方根据商户指令从该银行账户内扣款的支付方式。乙方在指定商户办理支付业务时不需再跳转到甲方支付页面，直接通过商户系统向甲方发起交易申请，完成支付（含分期）。
    </p>
    <p class="sp_cl">甲乙双方同意，上述授权的前提是，由商户收集并向甲方提供的乙方在申请本业务过程中所填写的要素，包括但不限于银行卡号、手机号码等，通过甲方的校对核验。</p>
    <p class="sp_cl">
      <strong>第二条、</strong>甲方的权利和义务
    </p>
    <p
      class="sp_cl"
    >1.甲方为乙方提供本协议约定的电子支付服务。乙方授权甲方按照商盟商务服务有限公司（以下简称“商盟”）向甲方提交的支付扣款指令及支付扣款数据，直接从乙方指定的银行账号中扣缴相关费用至该商户指定的银行账户。</p>
    <p class="sp_cl">2.乙方经商盟向甲方提交银行卡号、手机号码等信息，甲方校对核验后建立乙方银行账号与商户网站用户号的绑定支付关系。</p>
    <p class="sp_cl">2.乙方经商盟向甲方提交银行卡号、手机号码等信息，甲方校对核验后建立乙方银行账号与商户网站用户号的绑定支付关系。</p>
    <p
      class="sp_cl"
    >3.甲方不对商户提交的扣款交易指令进行实质性审核，不负责审核商户提交扣款指令的真实性、合法性、准确性。乙方如对甲方依据商户指令进行扣款的行为发生争议，应与其授权商户协商解决。</p>
    <p
      class="sp_cl"
    >4. 甲方可根据业务发展需要，设置或修改支付限额。乙方在使用本服务时需同时受甲方和商盟设置的支付限额的约束。如实际支付金额大于支付限额，甲方将拒绝执行交易指令。</p>

    <p
      class="sp_cl"
    >5.为保护乙方权益，控制业务风险，甲方有权随时变更乙方开通快捷支付后通过甲方进行电子支付时的身份验证方式，例如甲方可要求乙方在选择快捷支付时应当通过甲方网上银行或账号验证，或者使用网银盾或者短信验证码等方式作为校验标准。</p>
    <p class="sp_cl">
      <strong>第三条、</strong>乙方的权利和义务
    </p>
    <p class="sp_cl">1.乙方应先拥有甲方借记卡（折）或贷记卡银行账号，并遵守《中国建设银行股份有限公司电子银行个人客户服务协议》。</p>
    <p class="sp_cl">
      <strong>2.乙方向甲方承诺:其已授权商盟向甲方提交支付扣款指令及支付扣款数据；乙方保证商盟向甲方提交的支付扣款指令及支付扣款数据均为乙方真实意愿表示，该指令及数据真实、合法且有效，乙方愿意承担相关法律后果。</strong>
    </p>
    <p
      class="sp_cl"
    >3. 乙方在使用本服务时需同时受甲方和商盟设置的支付限额的约束。在任何情况下，支付金额不应超过甲方或商盟设置的支付限额（以较少者为准，以下简称“支付限额”）。如实际支付金额大于支付限额，甲方将拒绝执行交易指令。</p>
    <p class="sp_cl">
      <strong>4.乙方应妥善保管本人身份证件、银行账号、银行账号密码、网上银行交易密码、网上银行登陆密码、手机动态验证码、网银客户号以及网银盾等安全认证工具，不得将本人银行密码、手机动态验证码等信息向他人透露，否则由此导致的乙方损失，甲方不承担赔偿责任。</strong>
    </p>
    <p class="sp_cl">
      <strong>5.乙方应保证业务开通时在甲方预留的手机号（开户以及开通网银、手机银行等电子渠道时预留的手机号码）为本人手机号码，否则由此导致的乙方损失，甲方不承担赔偿责任。</strong>
    </p>
    <p class="sp_cl">
      <strong>6．乙方不得利用总对总快捷业务进行套现、虚假交易、洗钱等行为，且有义务配合甲方进行相关调查，一旦乙方拒绝配合进行相关调查或甲方认为乙方存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，甲方有权采取以下一种、多种或全部措施：（1）暂停或终止提供本协议项下总对总快捷服务；（2）终止本协议；（3）暂停或终止为乙方提供银行卡相关服务。</strong>
    </p>
    <p class="sp_cl">
      <strong>第四条、</strong>在本协议下甲方仅向乙方提供支付结算服务。乙方因购买或使用商盟的产品或服务而产生的一切关于产品质量、服务质量及费用扣收的争议，均由乙方与商盟自行协商解决。
    </p>
    <p class="sp_cl">
      <strong>第五条、</strong>甲乙双方在履行本协议的过程中如发生争议，应协商解决；协商不成的，向甲方住所地人民法院提起诉讼。
    </p>
    <p class="sp_cl">本协议适用中华人民共和国法律。为本协议之目的，中华人民共和国法律不包括香港特别行政区、澳门特别行政区及台湾地区法律。</p>
    <p class="sp_cl">
      <strong>第六条、</strong>特别约定条款如下：
    </p>
    <p
      class="sp_cl"
    >1.乙方承诺在指定的银行付款账户中保留足够的余额，并保持账户处于正常状态。因付款账户余额不足、账户被冻结、销户等原因而导致的无法成功支付费用及所造成的纠纷和违约责任、损失等法律后果乙方自担。</p>
    <p class="sp_cl">2. 乙方支付费用的发票等由商盟提供，甲方无需协助传递。</p>
    <p class="sp_cl">3. 乙方承诺如对扣费项目、扣费金额等有异议，将自行与收款方协商处理。</p>
    <p class="sp_cl">
      <strong>4. 甲方接收到的商户电子扣款指令信息不明确、不完整、不清晰或无法辨认，导致甲方无法扣款，甲方不承担责任，由乙方与其授权商户协商解决。</strong>
    </p>
    <p class="sp_cl">
      <strong>5.如乙方授权商户向甲方传送的银行卡号、手机号码等信息有误，导致甲方不能按约定扣划资金或致使乙方及商户发生损失的，甲方不承担责任，由乙方与其授权商户协商解决。</strong>
    </p>
    <p class="sp_cl">
      <strong>第七条、</strong>不可抗力
    </p>
    <p class="sp_cl">
      <strong>因不可抗力（包括但不限于甲方不能预见、不能避免并不能克服的战争、暴动、自然灾害、政府行为、社会事件、黑客攻击、供电、通讯运营商故障等客观情况）导致乙方损失的，甲方将视情况协助乙方解决或提供必要的帮助。根据不可抗力的影响，甲方部分或全部免除责任。</strong>
    </p>
    <p class="sp_cl">
      <strong>第八条、乙方选择并点击本协议下方“同意”按钮后，即为同意并签署本协议。</strong>
    </p>
    <p class="sp_cl">
      <strong>第九条、</strong>如甲方与商盟业务合作终止后，自终止之日起本协议自动失效。乙方如需注销总对总快捷业务，乙方可以通过商户端发起注销申请，业务注销自甲方同意并在银行系统中设置成功后生效。
    </p>
    <p class="sp_cl">
      <strong>第十条 乙方确认：已仔细阅读了本协议，并特别注意了字体加黑的条款，对本协议条款的含义及相应的法律后果已全部知晓并充分理解，愿意遵守其全部内容；甲方已应要求对相关条款进行了充分的提示和说明。</strong>
    </p>
    <br />
    <br />
    <br />
    <p class="sp_cl">
      若您为建设银行持卡人，使用建设银行活期储蓄账户或信用卡账户进行快捷支付，您还同意与中国建设银行股份有限公司签订《中国建设银行总对总快捷客户授权协议》，并通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受《中国建设银行总对总快捷客户授权协议》的全部内容
    </p>
    <h2 class="center">
      <strong>中信银行借记卡快捷支付线上服务协议</strong>
    </h2>
    <h2 class="center">
      <strong>1.0版，2016年）</strong>
    </h2>
    <p class="sp_cl">
      <strong>重要提示：</strong>
    </p>
    <p class="sp_cl">
      本协议是由<strong>中信银行股份有限公司</strong>（即本协议乙方）与乙方持卡人(即本协议甲方)就借记卡快捷支付服务的使用等相关事项所订立的有效合约。
    </p>
    <p class="sp_cl">
      本协议项下“借记卡快捷支付服务”，指乙方为甲方提供的资金划转、支付服务，其目的是协助甲方便捷地完成货币资金合法支付、结算，但该服务存在因技术、不可抗力等原因造成的支付失败、无法结算等风险。
    </p>
    <p class="sp_cl">
      甲方通过互联网（Internet）点击确认或以其他方式选择接受本协议，即表示同意接受本协议的全部约定内容，确认承担由此产生的一切责任。
    </p>
    <p class="sp_cl">
      <strong>在接受本协议之前，请甲方仔细阅读本协议的全部内容（特别是以黑体标注的内容）。如果不同意本协议的任何内容，或者无法准确理解相关条款的解释，请不要进行后续操作。</strong>
    </p>
    <p class="sp_cl">
      为明确双方的权利和义务，规范业务行为，双方本着平等互利的原则，就借记卡快捷支付服务相关事宜达成本协议。
    </p>
    <p class="sp_cl">
      第一条定义
    </p>
    <p class="sp_cl">
      下列用语在本协议中的含义为：
    </p>
    <p class="sp_cl">
      “本服务”指乙方根据本协议约定提供的借记卡快捷支付服务。本服务开通后，甲方在合作商户网站或相关使用界面输入快捷支付账户支付密码及收到的手机校验码后，<strong>即视为甲方确认支付金额及该支付指令，并同意由合作商户转交乙方进行后续处理。甲方同意并授权乙方按照合作商户的交易指令从甲方绑定的借记卡账户中支付相应款项，为此乙方不必事先通知甲方。如甲方借记卡内余额不足时，甲方知晓并同意乙方拒绝执行交易指令。</strong>
    </p>
    <p class="sp_cl">
      “乙方”指本协议乙方，即中信银行股份有限公司。
    </p>
    <p class="sp_cl">
      “甲方”指本协议甲方，即持有中信银行股份有限公司借记卡的持卡客户。
    </p>
    <p class="sp_cl">
      “合作商户”指甲方选择购买商品或服务的企业商户，或为甲方提供相关服务的非金融支付机构。
    </p>
    <p class="sp_cl">
      “借记卡”、“银行账户”指甲方在乙方开立的、用于开通借记卡快捷支付服务的银行借记卡及其对应银行账户。
    </p>
    <p class="sp_cl">
      “快捷支付账户”指甲方在合作商户开立的、与“银行账户”绑定的支付账户。快捷支付账户的开通、管理由合作商户负责，具体权利义务内容以甲方与合作商户的约定为准。
    </p>
    <p class="sp_cl">
      “身份信息及卡信息”指该开通快捷支付服务的借记卡、银行账户的开户户名、开户类型、与之相关的证件类型及证件号码、手机号码、固定电话、通信地址等与该借记卡有关的一切信息。
    </p>
    <p class="sp_cl">
      “支付限额”指乙方或合作商户设置的对快捷支付服务支付金额的额度限制，以较低者为准。
    </p>
    <p class="sp_cl">
      第二条快捷支付服务的申请确认
    </p>
    <p class="sp_cl">
      <strong>甲方确认并同意：乙方可向合作商户披露甲方在乙方登记的身份信息及卡信息，</strong>并对甲方在使用本服务过程中所填写的包括但不限于姓名、借记卡卡号、手机号码、身份证号码等<strong>进行校对核验</strong>；并同意将该借记卡与甲方此次登录的快捷支付账户进行绑定，以便甲方此次及今后进行支付。<strong>同时乙方与合作商户保留随时变更校验标准的权利。</strong>
    </p>
    <p class="sp_cl">
      <strong>甲方确认并同意：乙方、合作商户为本服务的开通及使用（含甲方取消绑定或停止使用本服务或借记卡销户、借记卡挂失、补办新卡等情况）相互传递甲方的个人资料。</strong>甲方保证所提供的姓名、借记卡卡号、手机号码、身份证号码等信息真实有效，<strong>因甲方提供虚假信息而引起的法律责任由甲方承担。</strong>
    </p>
    <p class="sp_cl">
      第三条甲方权利义务
    </p>
    <p class="sp_cl">
      一、权利
    </p>
    <p class="sp_cl">
      （一）甲方自愿申请开通本服务，经乙方同意后，将有权享受快捷支付服务。
    </p>
    <p class="sp_cl">
      （二）甲方有权办理本服务相关资料和信息变更、业务暂停、恢复和注销手续。
    </p>
    <p class="sp_cl">
      （三）甲方对本服务如有疑问、建议或意见，有权致电乙方服务热线“95558”、登录乙方官方网站或到乙方各营业网点咨询。
    </p>
    <p class="sp_cl">
      二、义务
    </p>
    <p class="sp_cl">
      （一）甲方应按照我国相关法律、法规、规范性文件及乙方相关管理办法、交易规则及规章制度的规定，以及本协议的约定履行本协议。
    </p>
    <p class="sp_cl">
      （二）甲方应在使用本服务过程中，<strong>认真核对短信校验码、商户名称、交易金额等信息是否与正在进行的交易事项一致，</strong>因交易信息与交易事项不一致而造成的一切损失，乙方不承担责任。
    </p>
    <p class="sp_cl">
      （三）甲方同意不会将本服务使用权或连接权转移或转让他人。
    </p>
    <p class="sp_cl">
      （四）<strong>甲方不得利用本服务进行套现、虚假交易、洗钱等行为，且有义务配合乙方进行相关调查。</strong>一旦甲方拒绝配合进行相关调查或乙方认为甲方存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，乙方有权根据本协议约定采取处理措施。
    </p>
    <p class="sp_cl">
      <strong>（五）合作商户在本协议变更、终止前已接收并发送至乙方进行处理的交易指令仍有效，甲方应承担其后果。</strong>
    </p>
    <p class="sp_cl">
      （六）甲方在本协议中应承担如下保密义务：
    </p>
    <p class="sp_cl">
      1、甲方对在本服务中使用的密码、手机校验码、身份信息、卡信息以及乙方提供给甲方的任何信息（以下简称“保密信息”）负有妥善保管的义务，甲方应自行承担因该等保密信息泄密、遗忘以及其他因甲方未尽保管义务所导致的任何损失，乙方不负任何赔偿责任。
    </p>
    <p class="sp_cl">
      <strong>2、甲方应按照以下原则设置和保管密码：避免使用姓名、生日、电话号码等与本人明显相关的信息作为密码；不得将本人自设密码提供给除法律规定外的任何人；通过手机银行办理业务后，须将自设密码从手机上删除；采取其他合理措施，防止本人密码被窃取。由于违反上述要求造成密码泄露的后果应由甲方自行承担。</strong>
    </p>
    <p class="sp_cl">
      3、凡使用密码进行的交易，均视为甲方本人所为，依据密码等电子数据信息办理的各类结算交易所产生的电子信息交易记录均为该项交易的有效凭证。
    </p>
    <p class="sp_cl">
      4、如上述保密信息出现或可能出现遗失、被窃或被其他人知悉的情况时，甲方应立即通知乙方并办理挂失。在挂失生效前发生网上支付的损失由甲方自行承担，乙方不承担任何法律责任。
    </p>
    <p class="sp_cl">
      （七）在使用本服务过程中，上述保密信息如有更改，甲方应及时至乙方营业网点或通过网上银行办理有关变更手续，办妥上述手续之前所产生的一切后果由甲方承担。
    </p>
    <p class="sp_cl">
      （八）甲方不得以与合作商户发生纠纷为由拒绝支付应付乙方的款项。
    </p>
    <p class="sp_cl">
      第四条乙方权利义务
    </p>
    <p class="sp_cl">
      一、权利
    </p>
    <p class="sp_cl">
      （一）乙方有权根据甲方的资信情况，决定是否为甲方开通本服务。当乙方有合理理由认为甲方提供的资料有误、不实、陈旧或不完善时，乙方有权暂停或终止向甲方提供部分或全部服务，甲方将承担因此而产生的全部损失与责任。
    </p>
    <p class="sp_cl">
      （二）乙方有权对本服务支付系统进行升级、改造。
    </p>
    <p class="sp_cl">
      （三）乙方可根据业务发展需要，设置或修改借记卡的支付限额，甲方对此无异议。甲方在使用本服务时需同时受乙方和合作商户设置的支付限额的约束。在任何情况下，支付金额不应超过乙方或合作商户设置的支付限额（以较低者为准）。如单笔交易指令中的支付金额高于支付限额，甲方同意乙方有权拒绝执行该交易指令。
    </p>
    <p class="sp_cl">
      （四）如甲方拒绝配合乙方进行虚假交易、洗钱、套现等相关活动的调查，或乙方认为甲方存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，乙方有权采取如下措施：
    </p>
    <p class="sp_cl">
      1、暂停或终止提供本协议项下快捷支付服务；
    </p>
    <p class="sp_cl">
      2、终止本协议；
    </p>
    <p class="sp_cl">
      3、取消甲方的借记卡使用资格。
    </p>
    <p class="sp_cl">
      <strong>（五）乙方保留向甲方收取使用本服务的服务费及对服务费进行调整的权利。收费方式及收费标准、优惠措施及其生效和终止日期等以乙方通过手机银行、网站、其他电子渠道或营业网点等适当方式公告的内容为准。收费标准变更的，乙方将在上述渠道提前进行公告，不再另行通知甲方。未经公告，乙方不得单方面提高收费标准。除非另有说明，对于上述服务费用，乙方有权从甲方在中信银行开立的任一账户中先行扣除。</strong>
    </p>
    <p class="sp_cl">
      （六）甲方出现未按时支付本服务有关费用、不遵守乙方有关业务规定或存在恶意操作、诋毁、损害乙方声誉等情况的，乙方有权单方终止对甲方提供本服务，并保留追究甲方法律责任的权利。
    </p>
    <p class="sp_cl">
      （七）乙方保有对本协议条款、条件进行修改、增删的权利，本协议如有修改、增删时，乙方会通过乙方网站公告变更事项。甲方可于任何时间至乙方网站查询最新的服务合约，网址是http://bank.ecitic.com/ ；或致电24小时客户服务热线95558。甲方在公告执行后继续使用快捷支付服务的，视同接受有关公告修改、变更的内容。
    </p>
    <p class="sp_cl">
      二、义务
    </p>
    <p class="sp_cl">
      （一）在乙方系统正常运行情况下，乙方负责及时准确地处理甲方或合作商户发送的交易指令，并及时向甲方提供查询交易记录、资金余额、账户状态等服务。但因合作商户反馈、传送的交易记录等信息有误，造成乙方查询结果错误的，乙方对此不承担责任，应由甲方与合作商户协商解决。
    </p>
    <p class="sp_cl">
      （二）乙方负责向甲方提供本服务的咨询服务，并通过乙方手机银行、网站、其他电子渠道或营业网点公布功能介绍、热点问题解答、交易规则等内容。
    </p>
    <p class="sp_cl">
      （三）乙方在法律法规许可和甲方的授权范围内使用甲方的资料和交易记录，但法律法规另有规定或监管机构要求乙方披露的除外。
    </p>
    <p class="sp_cl">
      第五条服务申明
    </p>
    <p class="sp_cl">
      <strong>一、甲方应确保甲方在使用本服务时绑定的乙方借记卡为甲方本人合法所有，并确保甲方将甲方的快捷支付账户与银行账户绑定且用其支付的行为合法、有效，未侵犯任何第三方合法权益；否则因此造成乙方、持卡人损失的，甲方应负责赔偿并承担全部法律责任。</strong>
    </p>
    <p class="sp_cl">
      <strong>二、因出现下列任一种情况导致甲方损失的，乙方均不承担任何赔偿责任：</strong>
    </p>
    <p class="sp_cl">
      <strong>(一)因乙方接受到的指令信息不明、存在乱码、不完整，或者甲方的银行账户余额不足或账户被冻结、扣划等非乙方原因导致该等指令未被乙方执行；</strong>
    </p>
    <p class="sp_cl">
      <strong>(二)因地震、台风、水灾、火灾、战争及其他不可抗力因素导致的甲方的损失；</strong>
    </p>
    <p class="sp_cl">
      <strong>(三)因乙方不可预测或无法控制的系统故障、通讯故障、供电系统故障、计算机黑客袭击、电脑病毒、恶意程序攻击等突发事故，给甲方造成的损失；</strong>
    </p>
    <p class="sp_cl">
      <strong>(四)因互联网传输原因，交易和转账指令出现中断、停顿、延迟、数据错误等情况以及乙方不可预测或不可控制因素造成的甲方的损失；</strong>
    </p>
    <p class="sp_cl">
      <strong>(五)甲方使用的个人电脑等终端设备发生任何软件或资料的遗失、硬件的损害等进而导致的甲方的损失。</strong> 
    </p>
    <p class="sp_cl">
      <strong>(六)因甲方未准确核对短信校验码、商户名称、交易金额等信息而造成的甲方的损失。</strong>
    </p>
    <p class="sp_cl">
      三、甲方通过本服务将银行账户内资金转出至快捷支付账户后，该转出资金的监管、计息将由合作商户负责，<strong>乙方不对转出资金进行计付利息、资金监管。</strong>
    </p>
    <p class="sp_cl">
      四、本服务开通后，乙方以合作商户反馈的、甲方与合作商户之间的订单信息为准，为甲方进行资金划付处理，但资金划付结果不代表合作商户提供的商品及服务质量、物流结果、权益落实等相关信息，乙方对商品及服务的质量、物流状态等不负有任何责任。因该等商品及服务的质量、物流及权益落实等原因产生的纠纷由甲方与合作商户或其他第三方自行解决，与乙方无关，乙方不承担任何责任。
    </p>
    <p class="sp_cl">
      第六条协议终止
    </p>
    <p class="sp_cl">
      一、甲方有权取消本服务。但在甲方取消本服务的终止验证申请生效之前，甲方通过本服务完成的交易仍属有效，甲方不得否认。
    </p>
    <p class="sp_cl">
      二、若甲方违反本协议约定，乙方有权直接终止为甲方提供本服务，而无需事先通知。
    </p>
    <p class="sp_cl">
      三、甲方在使用乙方借记卡的权利被终止时，甲方使用本服务的权利随同终止。 
    </p>
    <p class="sp_cl">
      四、甲方同意，如乙方与合作商户终止就本服务的合作，则本协议自动终止。
    </p>
    <p class="sp_cl">
      第七条差错处理
    </p>
    <p class="sp_cl">
      因甲方未按本服务规定流程进行操作，或由于甲方自身的其他原因造成本服务指令未执行、未适当执行、延迟执行的，应及时拨打乙方服务热线“95558”或到营业网点通知乙方。<strong>乙方将积极调查并告知甲方调查结果，但不承担由此产生的损失的赔偿责任。</strong>
    </p>
    <p class="sp_cl">
      第八条法律适用及争议解决
    </p>
    <p class="sp_cl">
      本协议的成立、生效、履行和解释，均适用中华人民共和国法律（为协议之目的，不包括港澳台地区法律）；法律法规无明文规定的，可适用通行的金融惯例。
    </p>
    <p class="sp_cl">
      <strong>因本协议项下具体业务发生的争议，双方应协商解决。协商不成的，应由发生争议的具体快捷支付服务对应的借记卡开户分行住所地人民法院管辖。</strong>
    </p>
    <p class="sp_cl">
      第九条其它
    </p>
    <p class="sp_cl">
      一、本协议签署后，若有关法律法规、规章制度及行业规章修订，相关内容及条款按新修订的法律法规、规章制度及行业规章办理，但本协议其他内容及条款继续有效。
    </p>
    <p class="sp_cl">
      本协议所指的通知方式除上述条款中已有约定外，可以是书面送达通知或公告通知。
    </p>
    <p class="sp_cl">
      书面送达通知、要求、诉讼（仲裁）的法律文书或其他通信，可交付或发送至本协议所约定的地址或联系方式。本协议项下乙方给予甲方的任何通知、要求或其他通信，其中电传、电话、传真、电子邮件等一经发出即视为已送达；邮政信函于投寄之日起第三日即视为已送达；如派人专程送达，则甲方签收日视为送达，甲方拒收的，送达人可采取拍照、录像方式记录送达过程，并将文书留置，亦视为送达。
    </p>
    <p class="sp_cl">
      司法机关或仲裁机构亦按本协议约定的地址、联系方式向甲方发送相关（法律）文书，无人签收或甲方拒收的，则（法律）文书退回之日视为送达之日；如直接送达时甲方拒收的，送达人可采取拍照、录像方式记录送达过程，并将（法律）文书留置，亦视为送达。甲方提供错误联系方式或未及时告知变更后联系方式的，导致（法律）文书未能送达或退回的，则（法律）文书退回之日视为送达之日。
    </p>
    <p class="sp_cl">
      如果甲方提供的上述联系方式发生变更的，应在变更后三日内书面通知乙方；否则按原联系方式发出的通知或其他文书，即使变更方没有收到，仍视为送达。
    </p>
    <p class="sp_cl">
      公告通知自公告在指定报刊或乙方官方网站或经营场所发布之日起生效。
    </p>
    <p class="sp_cl">
      三、本协议自乙方在电子银行系统为甲方完成本服务开通手续后立即生效。
    </p>
    <p class="sp_cl">
      四、本协议是乙方的其他既有协议的补充而非替代性文件。本协议未尽事宜依照《中信银行人民币借记卡章程》、《中信银行外币借记卡客户须知（单币卡）》、《中信银行外币借记卡章程》、《中信银行个人电子银行业务章程》、《中信银行电子银行个人客户服务协议》及乙方就本服务及相关事项不时补充、制订的规定。如本协议与其他既有协议就本服务同一事项的约定冲突的，应以本协议为准。
    </p>
    <p class="sp_cl">
      <strong>乙方已采取加粗、加黑、突出显示等合理方式提请甲方注意本协议项下免除或限制其责任的条款，并按甲方要求对有关条款予以充分说明；甲乙双方对本协议所有条款内容的理解不存在异议。</strong>
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped lang="less">
.agreement {
  text-align: left;
  padding: 20px;
  .sp_cl {
    text-indent: 2em;
    margin-bottom: 8px;
  }
  .sp_lf {
    text-align: left;
  }
  .sp_underLine {
    text-decoration: underline;
  }
  .center {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>